import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_469 implements Validator {

    public static id = 'CTRL_469';
    private message = 'error.ctr_469';


    public LOG: LogService = new LogService(CTRL_469);


    validate(form: any, map) {

        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_469.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const nbParticipantsWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const nbMaxParticipantsWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const nbParticipants = form.controls[nbParticipantsWithStepId];
                const nbMaxParticipants = form.controls[nbMaxParticipantsWithStepId];
                if (nbParticipants.value && nbMaxParticipants.value) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}




